import { render, staticRenderFns } from "./PartCard.vue?vue&type=template&id=21a116f0&scoped=true"
import script from "./PartCard.ts?vue&type=script&lang=ts&external"
export * from "./PartCard.ts?vue&type=script&lang=ts&external"
import style0 from "./PartCard.scss?vue&type=style&index=0&id=21a116f0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a116f0",
  null
  
)

export default component.exports